// latest: zhangmyh 2017-10-21 7:48 PM
import { Model } from 'common'
// 企业资质证件要求子表
Model.define('template.qlfinfo', {
  meta: {
    id: '',
    templetId: '',
    qualifyId: '',
    qualifyName: '',
    description: '',
    isDecision: ''
  }
})



// WEBPACK FOOTER //
// ./src/data/model/qualifyTpl/qualifyInfos.js